import { render, staticRenderFns } from "./HighlightModeSelector.vue?vue&type=template&id=766cfbf8&"
import script from "./HighlightModeSelector.vue?vue&type=script&lang=js&"
export * from "./HighlightModeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('766cfbf8')) {
      api.createRecord('766cfbf8', component.options)
    } else {
      api.reload('766cfbf8', component.options)
    }
    module.hot.accept("./HighlightModeSelector.vue?vue&type=template&id=766cfbf8&", function () {
      api.rerender('766cfbf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/HighlightModeSelector.vue"
export default component.exports